import { TutorialId } from "../store/slices/tutorialSlice";
export type { TutorialId };

export interface TutorialMeta {
  id: TutorialId;
  title: string;
  description: string;
  totalSteps: number;
  order: number;
}

export const DEFAULT_TUTORIAL_ID: TutorialId = "device_onboarding";

export const TUTORIAL_REGISTRY: Record<TutorialId, TutorialMeta> = {
  device_onboarding: {
    id: "device_onboarding",
    title: "Device Onboarding",
    description:
      "Walk the Add Device wizard end to end and watch your first agent come online.",
    totalSteps: 8,
    order: 1,
  },
  device_configuration: {
    id: "device_configuration",
    title: "Device Configuration",
    description:
      "Configure monitored ROS2 topics and device recordings.",
    totalSteps: 6,
    order: 2,
  },
  dashboard_panels: {
    id: "dashboard_panels",
    title: "Visualizing Telemetry",
    description:
      "Create a Host Map panel on the Default dashboard to monitor CPU usage across your fleet.",
    totalSteps: 8,
    order: 3,
  },
  lichtblick_recordings: {
    id: "lichtblick_recordings",
    title: "Recordings & Multimodal Viewer",
    description:
      "Slice data from a device rolling buffer, upload it, and inspect synchronized playback in Lichtblick.",
    totalSteps: 7,
    order: 4,
  },
};

export const TUTORIALS = Object.values(TUTORIAL_REGISTRY).sort(
  (a, b) => a.order - b.order,
);
